module.exports = __webpack_public_path__ + "img/coins-agree-confirm.3bd6af36.png";